import React, { useEffect, useState } from 'react';
import './sidebar.css';
import { NavLink } from 'react-router-dom';
import { ROUTES_LIST } from '../../helpers/routesList';
import { useAuth } from '../providers/AuthProvider';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GroupIcon from '@mui/icons-material/Group';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import AutoAwesomeMotionRoundedIcon from '@mui/icons-material/AutoAwesomeMotionRounded';
import { USER_ROLES } from '../../configs/constants';
import { getDataItem } from '../../helpers/getDataItem';

export default function Sidebar({ showSidebar }) {
    const auth = useAuth();
    const user = auth.getUserData();

    const [expanded, setExpanded] = useState('panel1');
    const [newFilesNumber, setNewFilesNumber] = useState(0);

    async function getNotif() {
        try {
            const response = await getDataItem('/notification/uploaded-files');
            setNewFilesNumber(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (user?.role === USER_ROLES.ADMIN) {
            getNotif();
            const interval = setInterval(() => {
                getNotif();
            }, 10000);
            return () => clearInterval(interval);
        }
    }, []);

    // const roleCheck = () => {
    //     setUserRole(true);
    // };

    const isSuperAdmin = () => {
        return user?.role === USER_ROLES.SUPER_ADMIN;
    };

    const isAdmin = () => {
        return user?.role === USER_ROLES.ADMIN;
    };

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div className="sidebarWrapper">
            <div className="sidebarMenu">
                <div className="sidebarList">
                    <Accordion
                        className="sidebarItemAccordion"
                        expanded={expanded === 'panel1'}
                        onChange={handleChange('panel1')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <ExpandMoreIcon style={{ color: '#fe4f70' }} />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <ViewListRoundedIcon style={{ color: '#fe4f70' }} />
                            <Typography style={{ marginLeft: '10px' }}>
                                Хөтөлбөр
                            </Typography>
                        </AccordionSummary>
                        <>
                            <NavLink
                                to={ROUTES_LIST.epgPage}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li>Хөтөлбөр харах</li>
                            </NavLink>
                            <NavLink
                                to={ROUTES_LIST.programArchiveGraph}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li>Хөтөлбөр графкаар харах</li>
                            </NavLink>
                            
                            <NavLink
                                to={ROUTES_LIST.programFileList}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li className="uploadedFile">
                                    Хуулсан файлын жагсаалт
                                    {newFilesNumber > 0 ? (
                                        <span>{newFilesNumber}</span>
                                    ) : (
                                        ''
                                    )}
                                </li>
                            </NavLink>
                            <NavLink
                                to={ROUTES_LIST.foreignChannelList}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li>Гадаад сувгийн хөтөлбөр</li>
                            </NavLink>
                            <NavLink
                                to={ROUTES_LIST.epgProcess}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li>Хөтөлбөрийн явц</li>
                            </NavLink>
                            <NavLink
                                to={ROUTES_LIST.epgPosters}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li>Сувгийн постер</li>
                            </NavLink>
                        </>
                    </Accordion>
                    {/* <Accordion
                        className="sidebarItemAccordion"
                        expanded={expanded === 'panel3'}
                        onChange={handleChange('panel3')}
                    >
                        <AccordionSummary
                            expandIcon={
                                <ExpandMoreIcon style={{ color: '#fe4f70' }} />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <ArchiveIcon style={{ color: '#fe4f70' }} />
                            <Typography style={{ marginLeft: '10px' }}>
                                Архив
                            </Typography>
                        </AccordionSummary>
                        <>
                            <NavLink
                                to={ROUTES_LIST.programArchive}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li>Хөтөлбөр хугацаагаар харах</li>
                            </NavLink>
                        </>
                    </Accordion> */}
                    {isSuperAdmin() || isAdmin() ? (
                        <Accordion
                            className="sidebarItemAccordion"
                            expanded={expanded === 'panel2'}
                            onChange={handleChange('panel2')}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <ExpandMoreIcon
                                        style={{ color: '#fe4f70' }}
                                    />
                                }
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <GroupIcon style={{ color: '#fe4f70' }} />
                                <Typography style={{ marginLeft: '10px' }}>
                                    Админ тохиргоо
                                </Typography>
                            </AccordionSummary>
                            <>
                                <NavLink
                                    to={ROUTES_LIST.cmsUserList}
                                    className="sidebarListItem"
                                    activeClassName="sidebarListItemActive"
                                >
                                    <li>CMS хэрэглэгчид</li>
                                </NavLink>
                                <NavLink
                                    to={ROUTES_LIST.cmsUserCreate}
                                    className="sidebarListItem"
                                    activeClassName="sidebarListItemActive"
                                >
                                    <li>Хэрэглэгч бүртгэх</li>
                                </NavLink>
                                {/* <NavLink
                                to={ROUTES_LIST.cmsLogList}
                                className="sidebarListItem"
                                activeClassName="sidebarListItemActive"
                            >
                                <li>Хэрэглэгчийн лог</li>
                            </NavLink> */}
                            </>
                        </Accordion>
                    ) : (
                        <></>
                    )}
                    {isSuperAdmin() && (
                        <Accordion
                            className="sidebarItemAccordion"
                            expanded={expanded === 'panel4'}
                            onChange={handleChange('panel4')}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <ExpandMoreIcon
                                        style={{ color: '#fe4f70' }}
                                    />
                                }
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <AutoAwesomeMotionRoundedIcon
                                    style={{ color: '#fe4f70' }}
                                />
                                <Typography style={{ marginLeft: '10px' }}>
                                    Бусад
                                </Typography>
                            </AccordionSummary>
                            <>
                                <NavLink
                                    to={ROUTES_LIST.channelList}
                                    className="sidebarListItem"
                                    activeClassName="sidebarListItemActive"
                                >
                                    <li>ТВ Сувгууд</li>
                                </NavLink>
                                <NavLink
                                    to={ROUTES_LIST.programTypeList}
                                    className="sidebarListItem"
                                    activeClassName="sidebarListItemActive"
                                >
                                    <li>Хөтөлбөрийн Төрөл</li>
                                </NavLink>
                                <NavLink
                                    to={ROUTES_LIST.channelTypeList}
                                    className="sidebarListItem"
                                    activeClassName="sidebarListItemActive"
                                >
                                    <li>Суваг төрөл</li>
                                </NavLink>
                                  <NavLink
                                    to={ROUTES_LIST.execute}
                                    className="sidebarListItem"
                                    activeClassName="sidebarListItemActive"
                                >
                                    <li>
                                        Хөтөлбөр нэгтгэх
                                    </li>
                                </NavLink>
                                <NavLink
                                    to={ROUTES_LIST.downloadExample}
                                    className="sidebarListItem"
                                    activeClassName="sidebarListItemActive"
                                >
                                    <li>
                                        Жишээ файл татах
                                    </li>
                                </NavLink>
                            </>
                        </Accordion>
                    )}
                </div>
            </div>
        </div>
    );
}
